import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar, Toolbar, Box, Container, Typography, Button, IconButton, Drawer,
  List, ListItem, ListItemButton, ListItemText, Stack, Divider,
} from '@mui/material';
import { Menu as MenuIcon, Close as CloseIcon } from '@mui/icons-material';
import { C } from './theme';

const VpsNavbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const navItems = [
    { label: 'Home', target: 'hero' },
    { label: 'Packages', target: 'pricing' },
    { label: 'How It Works', target: 'process' },
    { label: 'Why Us', target: 'features' },
    { label: 'Sample Report', target: 'report' },
    { label: 'Reviews', target: 'reviews' },
    { label: 'FAQ', target: 'faq' },
  ];

  const handleItemClick = (target) => {
    setMobileOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(target);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(target);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <>
      {/* ── Top Announcement Bar ── */}
      <Box sx={{ background: C.gradient, py: 0.9, color: '#FFFFFF' }}>
        <Container maxWidth="xl">
          <Typography align="center" sx={{ fontSize: '0.82rem', fontWeight: 500 }}>
            🔗 Manual, white-hat backlinks from DA/DR 50+ sites — <strong>Google-safe, guaranteed.</strong>
            <Box component="span"
              onClick={() => handleItemClick('pricing')}
              sx={{ textDecoration: 'underline', cursor: 'pointer', ml: 1.5, opacity: 0.95, fontWeight: 700 }}>
              View Packages →
            </Box>
          </Typography>
        </Container>
      </Box>

      {/* ── Main Header / Navbar ── */}
      <AppBar position="sticky" elevation={0} sx={{
        background: '#FFFFFF',
        borderBottom: `1px solid ${C.border}`,
        color: C.textPrimary,
        zIndex: 1100,
        height: { xs: 64, md: 70 },
        overflow: 'hidden',
      }}>
        <Container maxWidth="xl" sx={{ height: '100%' }}>
          <Toolbar disableGutters sx={{ height: '100%', minHeight: 'unset', justifyContent: 'space-between', gap: 2 }}>

            <Box
              component="img"
              src="/assets/logo.png"
              alt="Premium Backlink Services"
              onClick={handleLogoClick}
              sx={{
                width: { xs: 170, md: 210 },
                height: 'auto',
                objectFit: 'contain',
                objectPosition: 'left center',
                cursor: 'pointer',
                display: 'block',
                flexShrink: 0,
              }}
            />

            <Stack direction="row" spacing={0.5} sx={{ display: { xs: 'none', lg: 'flex' } }}>
              {navItems.map((item) => (
                <Button key={item.label}
                  onClick={() => handleItemClick(item.target)}
                  sx={{
                    color: C.textPrimary, fontSize: '0.88rem', fontWeight: 600,
                    textTransform: 'none', px: 1.5, py: 0.8, borderRadius: '8px',
                    '&:hover': { background: C.bgSection, color: C.primary },
                  }}>
                  {item.label}
                </Button>
              ))}
            </Stack>

            <Stack direction="row" spacing={1.25} alignItems="center" sx={{ display: { xs: 'none', md: 'flex' } }}>
              <Button variant="contained" size="small"
                onClick={() => handleItemClick('pricing')}
                sx={{
                  background: C.primary, color: '#FFFFFF', textTransform: 'none',
                  borderRadius: '8px', fontSize: '0.84rem', fontWeight: 700, px: 2.2, py: 0.75,
                  boxShadow: 'none',
                  '&:hover': { background: C.primaryHover, boxShadow: 'none' },
                }}>
                View Packages
              </Button>
            </Stack>

            <IconButton onClick={handleDrawerToggle} sx={{ display: { lg: 'none' }, color: C.textPrimary }}>
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* ── Mobile Drawer ── */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        slotProps={{
          paper: {
            sx: {
              width: 300,
              backgroundColor: "#fff",
              p: 1,
            },
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box
            component="img"
            src="/assets/logo.png"
            alt="Premium Backlink Services"
            sx={{ height: 86, width: 'auto', objectFit: 'contain' }}
          />
          <IconButton onClick={handleDrawerToggle} sx={{ color: C.textPrimary }}><CloseIcon /></IconButton>
        </Box>
        <Divider sx={{ borderColor: C.border, mb: 2 }} />

        <List disablePadding>
          {navItems.map((item) => (
            <ListItem key={item.label} disablePadding>
              <ListItemButton onClick={() => handleItemClick(item.target)} sx={{ borderRadius: '8px', py: 1, '&:hover': { background: C.bgSection } }}>
                <ListItemText primary={item.label} primaryTypographyProps={{ color: C.textPrimary, fontWeight: 600, fontSize: '0.95rem' }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Divider sx={{ borderColor: C.border, my: 2 }} />

        <Button variant="contained" fullWidth onClick={() => handleItemClick('pricing')} sx={{ background: C.primary, color: '#FFFFFF', textTransform: 'none', borderRadius: '8px', fontWeight: 700 }}>
          View Packages
        </Button>
      </Drawer>
    </>
  );
};

export default VpsNavbar;
